import { Branch } from "@/types/branch";
import React from "react";
import { useNavigate } from "react-router-dom";

interface MerchantCardProps {
  merchant: Branch;
}

const MerchantCard: React.FC<MerchantCardProps> = ({ merchant }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    const isDevelopment = import.meta.env.VITE_ENV === "development";

    if (isDevelopment) {
      navigate(`/${merchant?.slug}`);
    } else {
      if (merchant?.custom_domain) {
        window.location.href = `https://${merchant.custom_domain}`;
      } else {
        window.location.href = merchant?.redirect_url || "/";
      }
    }
  };

  return (
    <div
      className="w-full h-full cursor-pointer flex items-center justify-center"
      onClick={handleClick}
    >
      {merchant.logo ? (
        <img
          src={merchant.logo}
          alt={`${merchant.name} Logo`}
          className="max-w-full max-h-full object-contain"
        />
      ) : (
        <span className="text-lg font-semibold text-center">
          {merchant.name}
        </span>
      )}
    </div>
  );
};

export default MerchantCard;
